var UploadStatus;
(function (UploadStatus) {
  UploadStatus["STARTED"] = "STARTED";
  UploadStatus["NO_CALLED"] = "NO_CALLED";
  UploadStatus["LOADED"] = "LOADED";
  UploadStatus["LOADING"] = "LOADING";
  UploadStatus["CANCELED"] = "CANCELED";
  UploadStatus["ERROR"] = "ERROR";
  UploadStatus["WARNING"] = "WARNING";
  UploadStatus["FILE_NOT_ALLOWED"] = "FILE_NOT_ALLOWED";
  UploadStatus["PROCESSING"] = "PROCESSING";
  UploadStatus["SUCCESS"] = "SUCCESS";
})(UploadStatus || (UploadStatus = {}));

export { UploadStatus };
